import { Link, Outlet, useLocation } from 'react-router-dom'
import React, {useRef, useState, useEffect} from 'react';
import ScrollToTop from "@/components/ScrollToTop";
import logo4Pic from '@/assets/images/logo4.png';
import copyrightPic from '@/assets/images/copyright.png';
import arrowSignUp from '@/assets/images/arrow-signup.png';
import { animateScroll } from "react-scroll";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';

function App() {
  const location = useLocation();
  const footerRef = useRef<HTMLElement>(null);
  // const [aboutClicked, setAboutClicked] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isBlur, setIsBlur] = React.useState(true);

  // 导航项配置
  const navItems = [
    { id: 'investment-solutions', offset: 0, path: '/?section=investment-solutions', label: 'Investment Solutions' },
    { id: 'polaris-20-fund', offset:-106, path: '/?section=polaris-20-fund', label: 'Polaris 20 Fund', hidden: true },
    { id: 'polaris-co-invest', offset:-106, path: '/?section=polaris-co-invest', label: 'Polaris Co-Invest', hidden: true },
    { id: 'data-research', offset:-106, path: '/?section=data-research', label: 'Data & Research', hidden: true },
    { id: 'why-private-tech', offset:-106, path: '/?section=why-private-tech', label: 'Why Private Tech' },
    { id: 'data-research-portal', offset:-106, path: '/?section=data-research-portal', label: 'Data & Research Portal' },
    { id: 'about', offset:-66, path: '/?section=about', label: 'About' }
    // { path: '/about', label: 'About', isScroll: true },
    // { path: '/data-research-portal', label: 'Data & Research Portal' }
  ];

  // 滚动到footer的函数
  // const scrollToFooter = () => {
  //   if (footerRef.current) {
  //     setAboutClicked(true);
  //     footerRef.current.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'start'
  //     });
  //     // 2秒后重置点击状态
  //     setTimeout(() => setAboutClicked(false), 2000);
  //   }
  // };

  // 在hash路由模式下获取实际路径（如从/#/signup中获取/signup）
  // 注意：在createHashRouter中，useLocation().pathname已经会返回正确的路径
  // 例如，对于URL #/signup，pathname会是 "/signup"
  // const getCurrentRoutePath = () => {
  //   return location.pathname;
  // };

  // 监听路由变化
  useEffect(() => {
    if (location.pathname !== currentPath) {
      setIsTransitioning(true);
      // 先让当前页面消失
      setTimeout(() => {
        setCurrentPath(location.pathname);
        // 再让新页面出现
        setTimeout(() => {
          setIsTransitioning(false);
        }, 150);
      }, 600);
    }
  }, [location.pathname, currentPath]);

  // 添加防抖状态
  const [isScrolling, setIsScrolling] = useState(false);
  const [canAutoScroll, setCanAutoScroll] = useState(false);
  const [currentSection, setCurrentSection] = useState('investment-solutions');

  // 监听路由查询参数，处理section滚动
  useEffect(() => {
    // 如果动画正在执行，则不再次触发
    if (isScrolling) {
      return;
    }
    if(!canAutoScroll) {
      return
    }
    // 只在根路径下处理section参数
    if (location.pathname === '/') {
      const searchParams = new URLSearchParams(location.search);
      const section = searchParams.get('section');

      if (section) {
        // 在navItems中查找匹配的section
        const navItem = navItems.find(item => item.id === section);

        if (navItem) {
          if(!navItem.hidden) {
            setCurrentSection(section)
          } else {
            // 非导航栏项目，要单独设置canAutoScroll
            setCanAutoScroll(true);
          }
          // 确保DOM已经渲染完成
          setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
              // 设置防抖状态为true，表示动画开始
              setIsScrolling(true);

              // 计算滚动目标位置，考虑navItem的offset
              const scrollTarget = element.offsetTop + (navItem.offset || 0);

              animateScroll.scrollTo(scrollTarget, {
                duration: 1000,
                ease: 'easeInOut',
                smooth: true,
                offset: 0
              });

              // 动画结束后重置防抖状态
              setTimeout(() => {
                setIsScrolling(false);
                setCanAutoScroll(false);
              }, 1000);
            }
          }, 0);
        }
      }
    }
  }, [location.search, location.pathname, navItems, isScrolling, canAutoScroll]);

  useEffect(() => {
    if(location.pathname!=='/'){
      setCurrentSection('')
    }
  }, [location.pathname]);
  // 处理导航点击
  const handleNavigation = () => {
    setIsNavigating(true);
    // 短暂延迟后重置状态，让动画有时间播放
    setTimeout(() => setIsNavigating(false), 400);
    setCanAutoScroll(true);
  };

  useEffect(() => {
    document.querySelectorAll('.scrollable-link').forEach((_)=>{
      _.addEventListener('click', ()=>{
        setCanAutoScroll(true)
      });
    })
  }, [location.pathname]);

  // 判断是否为当前路径
  const isActive = (id: string, section: string) => {
    // 只有在首页才有可能被选中
    return location.pathname==='/' && id === section;
  };

  // 获取导航项的样式类
  const getNavItemClass = (id:string, section: string) => {
    const baseClass = "px-3 py-2 text-base font-medium font-['Figtree'] tracking-tight relative cursor-pointer";
    const hoverClass = "hover:text-[#6E66E1]"
    const activeClass = isActive(id, section)
      ? "text-[#6E66E1]"
      : "text-[#414141]";
    return `${baseClass} ${activeClass} ${hoverClass}`;
  };

  // Throttle function for performance optimization
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  function throttle(func, wait) {
    let timeout:NodeJS.Timeout;
    return function executedFunction(...args: never[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  const updateActiveNavLink = ()=> {
    const sections = document.querySelectorAll('section[id],footer[id]');

    let curSection = '';

    sections.forEach(section => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const sectionTop = section.offsetTop - 106;
      const sectionHeight = section.clientHeight;

      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        curSection = section.getAttribute('id')||'';
        setCurrentSection(curSection);
      }
    });
  }

  const optimizedScrollHandler = throttle(function() {
    updateActiveNavLink();
  }, 100);

  window.addEventListener('scroll', optimizedScrollHandler, false);

  const submitForm = (e)=>{
    setIsBlur(false)
    const form = document.getElementById('emailForm') as HTMLFormElement
    if (!form.checkValidity()) {
      form.reportValidity();
      setTimeout(() => {
        setIsBlur(true)
      }, 100)
    } else {
      subscribe()
    }
  }
  const subscribe = async ()=>{
    const emailInput = document.getElementById('emailInput') as HTMLInputElement;
    const email = emailInput.value.trim();
    setIsSubscribing(true)
    const response = await axios.post(`${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/subscribe?email=${encodeURIComponent(email)}`);
    setIsSubscribing(false)

    if (response.data) {
      const { result } = response.data;
      if(result) {
        toast.success('Subscribe successfully.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        emailInput.value=''
      }
    }
  }
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop/>
      <ToastContainer />
      {/* 顶部导航栏 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 bg-white/60 backdrop-blur-xl border-b border-gray-200/30 shadow-sm animate-in slide-in-from-top-2 duration-500 transition-all duration-300 ${isNavigating ? 'bg-white/95' : ''}`}>
        <div className="max-w-[1440px] height-[60px] mx-auto py-[15px] px-6 sm:px-8 lg:px-10">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
                             <div className="flex items-center cursor-pointer group relative">
                 {/*Logo背景效果*/}
                 <div className="absolute inset-0 bg-gradient-to-r from-[#6E66E1]/0 to-[#A78BFA]/0 group-hover:from-[#6E66E1]/5 group-hover:to-[#A78BFA]/5 rounded-full transition-all duration-500 ease-out -mx-2 -my-1 px-2 py-1"></div>

                 {/*Logo*/}
                {/*
                 <img
                   src={logoPic}
                   alt="Polaris Capital Logo"
                   className="w-5 h-5 mr-2 transition-all duration-500 ease-out group-hover:rotate-12 group-hover:scale-110 relative z-10"
                 />
                */}
                 <svg
                   width="24"
                   height="28"
                   viewBox="0 0 32 37"
                   fill="none"
                   className="w-[24px] h-[28px] mr-2 transition-all duration-500 ease-out group-hover:rotate-12 group-hover:scale-110 relative z-10"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path d="M14.7915 31.5266C13.3414 25.628 8.79758 21.0073 3.48036 20.0242L-2.76355e-07 19.336L5.12387 17.2715C10.9245 14.912 13.5347 11.8644 15.1782 5.27753L16.3384 0.558594L16.9184 4.49104C17.8852 10.6847 21.2689 14.912 26.9728 17.2715L32 19.2377L27.9396 20.3192C22.719 21.7938 18.5619 26.2178 17.2085 31.9199L16.0483 36.4422L14.7915 31.5266Z" fill="#000000"/>
                 </svg>

                 <span className="text-black text-xl font-bold mr-1 transition-all duration-500 ease-out relative z-10">POLARIS</span>
                 <span className="text-black text-xl transition-all duration-500 ease-out relative z-10">CAPITAL</span>
               </div>
            </div>
            {/* 菜单部署暂时水平居中，添加样式flex-1 justify-center */}
            <div className="flex flex-1 items-center justify-center">
              <div className="hidden md:block px-8">
                <div className="ml-10 flex items-baseline space-x-4">
                  {navItems.filter(_=>!_.hidden).map((item) => {
                    // 所有菜单项使用路由跳转
                    // if (item.isScroll) {
                    //   return (
                    //     <button
                    //       key={item.path}
                    //       onClick={scrollToFooter}
                    //       className={getNavItemClass(item.path)}
                    //     >
                    //       {/* 悬停背景效果 */}
                    //       <div className={getHoverClass(item.path)}></div>
                    //
                    //       {/* 底部指示器 */}
                    //       <div
                    //         className={getIndicatorClass(item.path)}
                    //         style={{
                    //           background: 'linear-gradient(90deg, #6E66E1 0%, #8B7CF4 50%, #A78BFA 100%)'
                    //         }}
                    //       ></div>
                    //
                    //       {/* 文字内容 */}
                    //       <span className="relative z-10">{item.label}</span>
                    //     </button>
                    //   );
                    // }

                    // 其他菜单项使用路由跳转
                    return (
                        <Link
                            key={item.id}
                            to={item.path}
                            className={getNavItemClass(item.id, currentSection)}
                            onClick={handleNavigation}
                        >
                          {/* 文字内容 */}
                          <span className="relative z-10">{item.label}</span>
                          <svg className={`inline-block ml-1 relative -top-0.5`} width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.718546 9.60006L9.28273 1.03587L1.942 1.03587L1.87908 0.0501194L10.9676 0.0501197L10.9676 9.13864L9.98185 9.07572L9.98185 1.73499L1.41766 10.2992L0.718546 9.60006Z" strokeWidth="0.25" fill="currentColor" stroke="currentColor"/>
                          </svg>
                          {/* 导航加载指示器 */}
                          {isNavigating && (
                            <div className="absolute inset-0 rounded-lg"></div>
                          )}
                        </Link>
                    );
                  })}
                </div>
              </div>
              <div className="flex items-center space-x-4">
                {/* 语言选择器 */}
                {/* 中英文切换tab 暂时隐藏 flex -> display-none */}
                <div className="display-none items-center border border-[#888888] rounded-lg overflow-hidden hover:border-[#662BFE] transition-colors duration-300">
                  <span className="px-3 py-1 text-sm font-medium text-[#6E66E1] bg-white hover:bg-purple-50 transition-colors duration-300 cursor-pointer">EN</span>
                  <div className="w-px h-4 bg-gray-300"></div>
                  <span className="px-3 py-1 text-sm font-medium text-[#888888] bg-white hover:bg-gray-50 transition-colors duration-300 cursor-pointer">中</span>
                </div>

                {/* Sign In 按钮 */}
                {/* Sign In 按钮暂时隐藏 */}
                <Link
                  to="/login"
                  className="bg-gray-100 text-[#6E66E1CC] hover:text-[#6E66E1] px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out shadow-sm cursor-pointer display-none"
                >
                  Sign In
                </Link>

                {/* Sign Up 按钮 */}
                {/* Sign Up 按钮暂时隐藏 */}
                <Link
                    to="/signup"
                    className="relative bg-gradient-to-r from-[#6E66E1] via-[#4D47A9] to-[#3C387B] border-[#5147E5] text-white px-7 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out shadow-sm cursor-pointer hover:shadow-[2px_0px_11.300000190734863px_0px_rgba(110,102,225,1.00)] overflow-hidden display-none"
                    onMouseMove={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = e.clientX - rect.left;
                      const percentage = (x / rect.width) * 100;
                      const leftMiddlePercentage = percentage / 2;
                      const rightMiddlePercentage = percentage + (100 - percentage) / 2;
                      e.currentTarget.style.setProperty('--mouse-position', `${percentage}%`);
                      e.currentTarget.style.setProperty('--left-middle', `${leftMiddlePercentage}%`);
                      e.currentTarget.style.setProperty('--right-middle', `${rightMiddlePercentage}%`);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty('--mouse-position');
                      e.currentTarget.style.removeProperty('--left-middle');
                      e.currentTarget.style.removeProperty('--right-middle');
                    }}
                    style={{
                      '--mouse-position': '0%',
                      '--left-middle': '0%',
                      '--right-middle': '0%'
                    }}
                  >
                    <span className="relative z-10 flex items-center pointer-events-none">
                      Sign Up
                      <div className="w-3 h-3 ml-2 mr-1 inline-block relative top-0.5" >
                        <img
                          src={arrowSignUp}
                          alt="Sign Up"
                          className="object-cover"
                        />
                      </div>
                    </span>
                    {/* 基于鼠标位置的多色渐变 */}
                    <span className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-full"
                      style={{
                        backgroundImage: `linear-gradient(to right, #3C387B 0%, #4D47A9 var(--left-middle), #6E66E1 var(--mouse-position), #4D47A9 var(--right-middle), #3C387B 100%)`
                      }}></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className="max-w-[1440px] mx-auto relative px-6 sm:px-8 lg:px-10">
       {/* 子路由内容将在这里渲染 */}
       <div
         className={`transition-all duration-700 ease-in-out relative ${
           isTransitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
         }`}
       >
         {/* 过渡覆盖层 - 只覆盖页面内容，不影响菜单 */}
         {isTransitioning && (
           <div className="absolute inset-0 bg-white z-50 transition-opacity duration-300 ease-in-out"></div>
         )}
         <Outlet/>
       </div>
      </div>
      {/* 底部导航 */}
      <footer id="about" ref={footerRef} className="bg-[#F1F0F2]">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-8 lg:px-10 pt-16 pb-5">
          {/* 顶部品牌与订阅 */}
          <div className="text-center mb-14">
            <div className="flex items-center justify-center mb-10">
              <img src={logo4Pic} alt="POLARIS CAPITAL" className="object-contain" />
            </div>
            <h3 className="text-lg text-[#3E3E3E] max-w-2xl mx-auto mb-6">
              Stay ahead of the curve with exclusive updates on technology, pre‑IPO insights, portfolio highlights, and private Polaris trends—delivered straight to your inbox every Wednesday.
            </h3>
            <form id="emailForm" onSubmit={(e)=>{e.preventDefault();}} className="flex items-center justify-center gap-3 max-w-xl mx-auto">
              <input
                id="emailInput"
                type="email"
                placeholder="Email"
                className={`flex-1 px-5 h-11 text-[14px] text-[#424242] rounded-full bg-[#E5E4E6] border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${isSubscribing?'cursor-not-allowed':''}`}
                required
                disabled={isSubscribing}
                onKeyDown={(e) => {
                  setIsBlur(false);
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const input = e.target as HTMLInputElement;
                    input.setCustomValidity('');
                    if (!input.checkValidity()) {
                      // input.setCustomValidity('Please enter a valid email address');
                      input.setCustomValidity('');
                    }
                    input.reportValidity();
                  } else {
                    const input = e.target as HTMLInputElement;
                    // 将验证信息设置为多个空格，可让验证信息不显示
                    input.setCustomValidity('  ');
                  }
                }}
                onBlur={(e)=>{
                  const input = e.target as HTMLInputElement;
                  // input.setCustomValidity('');
                  if(!isBlur){
                    setIsBlur(true);
                    if (!input.checkValidity()) {
                      // input.setCustomValidity('Please enter a valid email address');
                      input.setCustomValidity('');
                    }
                    // input.reportValidity();

                  }

                }}
              />
              <button disabled={isSubscribing} onClick={submitForm} type="submit" className={`w-40 h-11 rounded-full bg-[#6E66E1] text-white text-sm font-bold font-['Figtree'] hover:bg-[#5c4fd6] transition-colors inline-flex items-center justify-center ${isSubscribing?'cursor-not-allowed':'cursor-pointer'}`}>
                Subscribe <svg className="w-3 h-3 ml-1 text-white transform rotate" fill="none" stroke="currentColor" strokeWidth="0.5" viewBox="0 0 12 12">
                <path d="M0.322291 10.3705L9.4982 1.19455L1.63314 1.19455L1.56572 0.138381H11.3034V9.87608L10.2473 9.80867L10.2473 1.9436L1.07134 11.1195L0.322291 10.3705Z" fill="white"/>
              </svg>
              </button>
            </form>
            <p className="mt-8 text-xs text-[#808080] max-w-xl mx-auto leading-relaxed">
              By subscribing, you agree to Polaris’ <Link to={`/privacy-policy`} target={`_blank`} className={`underline underline-offset-2`}>Privacy Policy</Link> and consent to the processing of your Personal Data to receive the guide and Polarising information on growth equity and pre‑IPO investments. You confirm that you have read and accepted the <Link to={`/disclaimer`} target={`_blank`} className={`underline underline-offset-2`}>Disclaimer</Link>. You may opt out at any time.
            </p>
          </div>

          {/* 链接分栏 */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-10 text-sm text-[#2B2B2B]">
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Who We Serve</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Private Wealth</li>
                <li>Family Office</li>
                <li>Institutional Investors</li>
                <li>Asia Private Investors</li>
              </ul>
            </div>
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Products</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Market Data</li>
                <li>Polaris 20</li>
                <li>Polaris Invest</li>
              </ul>
            </div>
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Resources</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Blog</li>
                <li>Events</li>
                <li>Documentation</li>
                <li>APIs</li>
              </ul>
            </div>
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">About Us</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Our Company</li>
                <li>Contact Us</li>
              </ul>
            </div>
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Contact Us</div>
              <ul className="space-y-2 text-[#121212CC] text-base font-medium font-['Figtree']">
                <li><a href="mailto:operation@polariscapitalai.com">operation@polariscapitalai.com</a></li>
              </ul>
            </div>
          </div>

          {/* 版权与底栏 */}
          <div className="mt-[88px] pt-2.5 border-t border-[#12121233] flex flex-col md:flex-row items-center justify-between text-sm text-[#121212CC]">
            <div className="flex items-center space-x-1 mb-4 md:mb-0 ">
              <div className="w-5 h-5 rounded-full text-sm flex items-center justify-center">
                <img
                  src={copyrightPic}
                  alt="Copyright"
                  className="w-5 h-5"
                />
              </div>
              <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']">Polaris Capital 2025</span>
            </div>
            <div className="flex items-center space-x-12">
              <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']"><Link to={`/terms-of-use`} target={`_blank`}>Terms of use</Link></span>
              <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']"><Link to={`/privacy-policy`} target={`_blank`}>Privacy policy</Link></span>
              <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']"><Link to={`/disclaimer`} target={`_blank`}>Disclaimer</Link></span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
